import { useRef, useEffect, useState } from 'react';
import { useNavigate} from 'react-router-dom';
import { collection, addDoc, doc, getDoc,} from 'firebase/firestore';
import { auth, db } from '../../Firebase/firebase';
import { useActiveComponent } from '../ActiveComponentContext.js';
import { Dialog, DialogContent, DialogTitle, Box } from '@mui/material';
import { categoryList } from '../../Data/pageData';
import { useTheme, useMediaQuery } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SummaryCard from '../SummaryCard/index.jsx';
import LargePostCardDialog from '../LargePostCardDialog/index.jsx';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../Firebase/firebase';

const FixedHorizontalScrollBox = ({
  data,
  category,
  username,
  userPhotoURL,
  userBannerImage,
  path,
  categoryLength,
  userPostsLength,
  featured,
  isUserProfilePage,
  userId,
  // postID,
  // height,
}) => {
  // Check if username is provided, useful for when this component is used to display posts according to user & not by category
  // Like we do in UsersPosts page where all their posts are displayed under their respective usernames
  const isUser = !!username;

  // console.log('userPhotoURL is', userPhotoURL)

  //Get backgroundColor state & setActivePath from ActiveComponent Context Provider
  const { backgroundColor, setActivePath } = useActiveComponent();
  // State for managing LargePostCardDialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  //This part allows click and drag of scrollable box
  const [isScrolling, setIsScrolling] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const scrollRef = useRef(null);
  const navigate = useNavigate();

  const fontColor = backgroundColor === '#ffffff' ? '#030202' : 'lightgrey';
  const usernameBoxShadow = username && '0px 2px 3px grey';

  // const isMdUp = useMediaQuery((theme) => theme.breakpoints.up('md')); // Check if screen size is medium or larger
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // Check if screen size is large or larger

  // Limit the number of SummaryCards displayed to a maximum of 8
  const dataDisplayLimit = 8;
  const limitedData = data.slice(0, dataDisplayLimit); // Get the first 8 items of array of data to be used in Summary Card

  const limiteUserProfileData = data.slice(0, dataDisplayLimit); // Get the first 8 items of array of data to be used in Summary Card

  //FUNCTIONS,
  // const handleCommentsCountChange = (count) => {
  //   setCommentsCount(count);
  // };

  const getCategoryIcon = (categoryName) => {
    const categoryItem = categoryList.find(
      (item) => item.name === categoryName
    );
    return categoryItem ? categoryItem.icon : null;
  };
  // //HandleClick is to handle navigation when title in Typography is clicked
  // const handleClick = (path) => {
  //   navigate(path);
  //   setActivePath(path);
  // };

  const handleClick = async (path, userId) => {
    if (!path && userId) {
      try {
        // Fetch username from userData using userId
        const userDoc = await getDoc(doc(db, "users", userId));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log("clicked username", userData.username )
          path = `/${userData.username}`; // Use the fetched username
        }
      } catch (error) {
        console.error("Error fetching username:", error);
        return;
      }
    }
    if (path) {
      // navigate(path);
      navigate(`/users/${userId}`);
      setActivePath(`/users/${userId}`);
      //console.log("i clicked the recoveredname for path", `/users/${userId}`)
      //router.push(path); // Navigate to the user's posts
    }
    // if(!path){
    //   navigate(`user/${userId}`)
    //   setActivePath(`user/${userId}`);
    //   console.log("i clicked the recoveredname", `user/${userId}`)
  
    // if (path) {
    //   navigate(path);
    //   setActivePath(path);
    //   //router.push(path); // Navigate to the user's posts
    // }
  };

  //Function to handle SummaryCard click and display LargePostDialog popUp
  const handleCardClick = (cardData) => {
    if (!cardData) {
      console.error('Card data is not available');
      return;
    }
    // Log the post click event with Firebase Analytics
    // logEvent(analytics, 'post_click', { postId: cardData.id });
    // Log custom event with both postId and userId
  logEvent(analytics, 'post_click', { 
    postId: cardData.id,
    userId: cardData.userId
  });

     // Proceed with opening the dialog or other actions
    setSelectedCard(cardData); // cardData now contains category too so above code not needed
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCard(null);
  };

  //set of functions to handle click, drag & scroll of cards in horizontal scroll box
  const handleMouseDown = (e) => {
    setIsScrolling(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };
  const handleMouseMove = (e) => {
    if (!isScrolling) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Scroll-fast
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };
  const handleMouseUpOrLeave = () => {
    setIsScrolling(false);
  };

  //For using hover-arrows to scroll back and forward
  const scrollBack = () => {
    scrollRef.current.scrollBy({
      left: -300, // Adjust the value for the desired scroll distance
      behavior: 'smooth',
    });
  };
  const scrollFront = () => {
    scrollRef.current.scrollBy({
      left: 300, // Adjust the value for the desired scroll distance
      behavior: 'smooth',
    });
  };

  // For handling horizontal scroll ability
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    scrollContainer.addEventListener('mousedown', handleMouseDown);
    scrollContainer.addEventListener('mouseleave', handleMouseUpOrLeave);
    scrollContainer.addEventListener('mouseup', handleMouseUpOrLeave);
    scrollContainer.addEventListener('mousemove', handleMouseMove);

    return () => {
      scrollContainer.removeEventListener('mousedown', handleMouseDown);
      scrollContainer.removeEventListener('mouseleave', handleMouseUpOrLeave);
      scrollContainer.removeEventListener('mouseup', handleMouseUpOrLeave);
      scrollContainer.removeEventListener('mousemove', handleMouseMove);
    };
  }, [startX, scrollLeft, isScrolling]);
  return (
    <>
      {/* Category Label at the top */}
      <Box
        p={1}
        //mt={6}
        mb={0}
        sx={{
          display: 'flex',
          justifyContent: userPhotoURL ? 'center' : 'center',
          alignItems: 'center',
          height: { xs: '10px', lg: '20px' },
          mb: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
          mt: { xs: 4, sm: 4, md: 4, lg: 5, xl: 5 },
        }}
      >
        {/* Specifically/Conditionally when COmpoent is used for UsersProfiles display */}
        {userPhotoURL && isUser ? (
          <Box
            //onClick={() => handleClick(`/${username}`)}
            onClick={() => handleClick(username ? `/${username}` : null, userId)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              borderRadius: '12px',
              mb: { xs: 5, sm: 3, md: 2, lg: 2, xl: 2 },
              mt: { xs: 3, sm: 3, md: 0, lg: 0, xl: 0 },
              backgroundSize: 'cover', // Adjust as needed
              backgroundPosition: 'center',
              height: '55px',
              width: 'auto',
              opacity: 0.9,
            }}
          >
            <IconButton
              disableRipple
              sx={{ p: 1.5 }}
              //onClick={() => handleClick(`/${username}`)} //sends to dynamic path made of username
              onClick={() => handleClick(username ? `/${username}` : null, userId)}
            >
              <Avatar
                src={userPhotoURL || '../images/siteImages/defaultAvatar.jpg'}
                sx={{
                  height: {
                    xs: '26px',
                    sm: '30px',
                    md: '30px',
                    lg: '33px',
                    xl: '30px',
                  },
                  width: {
                    xs: '26px',
                    sm: '30px',
                    md: '30px',
                    lg: '33px',
                    xl: '30px',
                  },
                  marginRight: 1,
                  '&:hover': {
                    boxShadow: '0px 0px 3px black',
                    transform: 'scale(1.06)', // Optional: adds a slight zoom effect
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  },
                }}
              />
              <Typography
                variant='h2'
                noWrap
                component='div'
                sx={{
                  boxShadow: usernameBoxShadow,
                  padding: '7px',
                  borderRadius: '8px',
                  display: 'flex',
                  fontFamily: 'Montserrat',
                  fontWeight: 300,
                  textShadow: '0px 0px 0.7px black',
                  letterSpacing: '.3rem',
                  fontSize: { xs: 10, sm: 10, md: 12, lg: 11, xl: 12 },
                  color: 'white',
                  backgroundColor: '#030202',
                  textDecoration: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    boxShadow: '0px -1px 4px inset grey',
                    transform: 'scale(1.03)', // Optional: adds a slight zoom effect
                    transition:
                      'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  },
                }}
              >
                {username}
                {/* {username || "Anonymous"} */}
              </Typography>
            </IconButton>
          </Box>
        ) : (
          <Typography
            variant='h2'
            noWrap
            component='div'
            sx={{
              alignItems: 'center',
              gap: 2,
              boxShadow: usernameBoxShadow,
              padding: '7px',
              borderRadius: '8px',
              display: 'flex',
              fontFamily: 'Montserrat',
              fontWeight: 300,
              textShadow: '0px 0px 0.7px black',
              letterSpacing: '.3rem',
              fontSize: { xs: 12, sm: 12, md: 13, lg: 15, xl: 15 },
              flexDirection: 'center',
              color: fontColor,
              textDecoration: 'none',
              cursor: 'pointer', // Change cursor to pointer to indicate it's clickable
              transition: 'all 0.3s ease-in-out',
            }}
            onClick={() => {
              handleClick(path);
            }}
          >
            {getCategoryIcon(category)} {category}
          </Typography>
        )}
      </Box>

      {/* category title ends */}
      {/* For Actual Box where Data is diaplsyed with horizontalScroll */}
      <Box
        sx={{
          overflowY: 'hidden',
          mb: { xs: 3, sm: 3, md: 3, lg: 4, xl: 4 },
          p: 0,
          position: 'relative',
          '&:hover': {
            scrollbarWidth: 'thin', // Show scrollbar on hover for Firefox
            '&::-webkit-scrollbar': {
              display: 'block', // Show scrollbar on hover for WebKit-based browsers
            },
            '& .scroll-hint': {
              opacity: 1, // Show the scroll hint on hover
            },
          },
        }}
      >
        <Box
          ref={scrollRef}
          alignItems='center'
          mx='auto'
          gap={8}
          p={0}
          sx={{
            //border:'2px solid red',
            overflowY: 'hidden',
            pt: {xs:1,sm:1, md:1,lg:1,xl:2},
            pb:{xs:1,sm:1, md:1,lg:1,xl:2},
            display: 'flex',
            borderRadius: 2,
            width: { xs: '95%', sm: '95%', md: '90%', lg: '90%', xl: '90%' },
            maxWidth: '100%',
            justifyContent: {
              xs:
                categoryLength > 3 || userPostsLength > 3
                  ? 'flex-start'
                  : 'flex-start',
              sm:
                categoryLength > 3 || userPostsLength > 3
                  ? 'flex-start'
                  : 'flex-start',
              md:
                categoryLength > 3 || userPostsLength > 3
                  ? 'flex-start'
                  : 'center',
              lg:
                categoryLength > 3 || userPostsLength > 3
                  ? 'flex-start'
                  : 'center',
              xl:
                categoryLength > 3 || userPostsLength > 3
                  ? 'flex-start'
                  : 'center',
            },
            overflowX: 'auto',
            height: {
              xs: '40vh',
              sm: '72vh',
              md: '45vh',
              lg: '40vh',
              xl: '40vh',
            },
            scrollbarWidth: 'none', // Hide scrollbar for Firefox
            '&::-webkit-scrollbar': {
              display: 'none', // Hide scrollbar for Webkit-based browsers (Chrome, Safari)
            },
            '&:hover': {
              scrollbarWidth: 'thin', // Show scrollbar on hover for Firefox
              '&::-webkit-scrollbar': {
                display: 'block', // Show scrollbar on hover for WebKit-based browsers
              },
              '& .scroll-hint': {
                opacity: 1, // Show the scroll hint on hover
              },
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Dynamically set the scrollbar color
            },
            cursor: isScrolling ? 'grabbing' : 'grab', // Change cursor style while dragging
          }}
        >
          {/* {data.map((dataItem, index) => ( */}
          {limitedData.map((dataItem, index) => (
            <Box
              key={`${dataItem.summary}-${index}`}
              sx={{
                flex: '0 0 auto',
                marginRight: 1,
                marginLeft: 1,
                flexDirection: 'row',
              }}
            >
              <SummaryCard
                id={dataItem.userId}
                postID={dataItem.id}
                image={dataItem.images[0]}
                title={dataItem.title}
                summary={dataItem.description}
                images={dataItem.images}
                photoURL={dataItem.userPhotoURL || '../images/siteImages/defaultAvatar.jpg'}
                username={dataItem.username} //pass the username to LargePostCard
                name={dataItem.name}
                email={dataItem.email}
                date={dataItem.readableDate}
                category={dataItem.category}
                location={dataItem.location || null}
                onClick={() => handleCardClick(dataItem)} // display LArgePostCardDialog
                vertical={'185px'}
                horizontal={'300px'}
              />
            </Box>
          ))}
        </Box>
        {/* Scroll hint overlay With Arrows & See All */}
        {/* Scroll (Left) Back Arrow */}
        {/* Conditionally render the left arrow based on number of content on page */}
        {isMdUp
          ? categoryLength > 3 && (
              <IconButton
                className='left-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  left: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 0, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollBack}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )
          : categoryLength > 1 && (
              <IconButton
                className='left-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  left: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 1, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollBack}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )}

        {/* back arrow conditionals for userprofiles page */}

        {isMdUp
          ? userPostsLength > 3 && (
              <IconButton
                className='left-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  left: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 0, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollBack}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )
          : userPostsLength > 1 && (
              <IconButton
                className='left-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  left: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 1, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollBack}
              >
                <ArrowBackIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )}

        {/* Scroll (Right) Forward Arrow */}
        {/* Conditionally render the right arrow */}
        {isMdUp
          ? categoryLength > 3 && (
              <IconButton
                className='right-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  right: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 0, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollFront}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )
          : categoryLength > 1 && (
              <IconButton
                className='right-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  right: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 1, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollFront}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )}

        {/* Arrow conditionals for userprofiles page */}

        {isMdUp
          ? userPostsLength > 3 && (
              <IconButton
                className='right-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  right: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 0, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollFront}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )
          : userPostsLength > 1 && (
              <IconButton
                className='right-arrow scroll-hint'
                sx={{
                  position: 'absolute',
                  right: 30,
                  top: '45%',
                  transform: 'translateY(-50%)',
                  opacity: 0,
                  transition: 'opacity 0.3s ease-in-out',
                  color: 'black',
                  backgroundColor: 'white',
                  '&:hover': {
                    boxShadow: '0px 2px 4px grey',
                    color: 'white',
                    backgroundColor: 'black',
                    opacity: { xs: 0, sm: 0, md: 1, lg: 1, xl: 1 },
                  },
                }}
                onClick={scrollFront}
              >
                <ArrowForwardIosIcon
                  sx={{ fontSize: { xs: 10, sm: 10, md: 14, lg: 18, xl: 18 } }}
                />
              </IconButton>
            )}

        {/* See All Button */}
        {/* Conditionally render the See All button- only shows if there's more to display beyond limit */}
        {categoryLength > dataDisplayLimit && (
          <Box
            className='scroll-hint'
            sx={{
              position: 'absolute',
              bottom: {
                xs: '-5%',
                sm: '-5%',
                md: '-5 %',
                lg: '-10%',
                xl: '-10%',
              },
              right: { xs: '-5%', sm: '0%', md: '2.5%', lg: '3%', xl: '3%' },
              transform: 'translate(-50%, -50%)',
              color: 'grey',
              padding: '4px 8px',
              borderRadius: '8px',
              opacity: 0, // Start as invisible
              transition: 'opacity 0.3s ease-in-out',
              '&:hover': { color: 'blue' },
              cursor: 'pointer',
              //pointerEvents: 'none', // Ensures this doesn't interfere with user interactions
            }}
            onClick={() => {
              if (userPhotoURL && isUser) {
                handleClick(`/${username}`); // If it's a user profile view, navigate to the user-specific path
              } else {
                handleClick(path); // Otherwise, navigate based on the provided path
              }
            }}
          >
            <Typography
              sx={{ fontSize: { xs: 11, sm: 11, md: 13, lg: 14, xl: 14 } }}
            >
              See More
            </Typography>
          </Box>
        )}

        {userPostsLength > dataDisplayLimit && (
          <Box
            className='scroll-hint'
            sx={{
              position: 'absolute',
              bottom: {
                xs: '-5%',
                sm: '-5%',
                md: '-5 %',
                lg: '-10%',
                xl: '-10%',
              },
              right: { xs: '-5%', sm: '-5%', md: '2.5%', lg: '3%', xl: '3%' },
              transform: 'translate(-50%, -50%)',
              color: 'grey',
              padding: '4px 8px',
              borderRadius: '8px',
              opacity: 0, // Start as invisible
              transition: 'opacity 0.3s ease-in-out',
              '&:hover': { color: 'blue' },
              cursor: 'pointer',
              //pointerEvents: 'none', // Ensures this doesn't interfere with user interactions
            }}
            onClick={() => {
              if (userPhotoURL && isUser) {
                handleClick(`/${username}`); // If it's a user profile view, navigate to the user-specific path
              } else {
                handleClick(path); // Otherwise, navigate based on the provided path
              }
            }}
          >
            <Typography
              sx={{ fontSize: { xs: 12, sm: 12, md: 13, lg: 14, xl: 14 } }}
            >
              See More
            </Typography>
          </Box>
        )}
      </Box>

      {/* PopUp Dialog displaying LargePostCardDialog */}
      {selectedCard && (
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth='lg'
          fullWidth
          PaperProps={{
            style: {
              maxHeight: 'calc(100vh - 15px)',
              overflowY: 'auto',
              height: '85vh',
              borderRadius: '24px',
            },
          }}
        >
          <DialogTitle sx={{ mb: 1.2, p: 1 }}>
            {/* {selectedCard.title} */}
            <IconButton
              aria-label='close'
              onClick={handleCloseDialog}
              sx={{
                position: 'absolute',
                right: { xs: 2, sm: 2, md: 4, lg: 8, xl: 8 },
                top: { xs: -4, sm: 1, md: 3, lg: 8, xl: 8 },
                // color: (theme) => theme.palette.grey[500],
                color: 'black',
                '&:hover': {
                  backgroundColor: 'indianred',
                  color: 'white',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              mt: 0,
              mb: 0,
              p: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <LargePostCardDialog
              id={selectedCard.userId}
              postID={selectedCard.id}
              images={selectedCard.images}
              title={selectedCard.title}
              summary={selectedCard.description}
              link={selectedCard.link}
              ratings={selectedCard.ratings}
              postInfo={selectedCard} // Pass the whole object
              photoURL={selectedCard.userPhotoURL}
              username={selectedCard.username} //pass the username to LargePostCard
              name={selectedCard.name}
              email={selectedCard.email}
              location={selectedCard.location || null}
              date={selectedCard.readableDate}
              category={selectedCard.category}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default FixedHorizontalScrollBox;

//TO CONTROL DIALOG WIDTH:
// maxWidth={false} // Disable maxWidth to have full control
// sx={{
//   '& .MuiDialog-paper': {
//     width: {
//       xs: 'md', // 90% of screen width on small screens
//       sm: '100%', // 80% of screen width on medium screens
//       md: '70%', // 70% on larger screens (up to `md`)
//       lg: '60%', // 60% on large screens (up to `lg`)
//       xl: 'md', // 50% on extra-large screens
//     },
//   },
// }}
